<div class="dialog-container d-flex justify-content-center align-items-center">
    <div class="spinner spinner-grow text-primary" role="status">
    </div>
    <div class="spinner spinner-grow text-primary" role="status">
    </div>
    <div class="spinner spinner-grow text-primary" role="status">
    </div>
</div>